
export function getGatewayApiUrl() {
  return "https://apigateway.palmswap.org/dev"
}
